import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ReferenceBox from '../../common/reference-box';
import Button from '../../common/button/button';
import articleTagsService from '../../../services/article-tags/article-tags';
import './open-source-project.css';

const seeInGithubButtonStyles = {
  button: {
    backgroundColor: 'rgba(43, 104, 156, 1)',
    border: 'solid rgba(43, 104, 156, 1) 0px'
  },
  label: {
    textTransform: 'capitalize'
  }
};

class OpenSourceProject extends Component {
  renderDemos() {
    if (this.props.demos.length === 0) {
      return null;
    }

    const demosJSX = this.props.demos.map((demo, i) =>
      <div key={`project-${this.props._id}-demo-${i}`}>
        <a href={`${demo.link}`} title={demo.title}>
          {demo.title}
        </a>
      </div>
    );

    return (
      <div className='project-section demos'>
        {demosJSX}
      </div> 
    );
  }

  getDemosJSXArray() {
    if (this.props.demos.length === 0) {
      return null;
    }

    const demosJSX = this.props.demos.map((demo) => {
      const demoProps = {
        _id: demo._id,
        title: demo.title,
        link: demo.link,
        isExternalResource: true,
        imgSrc: `/images/open-source/${this.props._id}/${demo._id}.gif`,
        writer: 'Dor Moshe',
        tags: articleTagsService.getRelevantMyArticleTags(demo.tags),
        buffText: 'Demo'
      }
      
      return (
        <div 
          key={`project-${this.props._id}-demo-${demo._id}`}
          className='project-reference-box-container little-grow-animation'>
            <ReferenceBox 
              {...demoProps} />
        </div>
      );
    }); 

    return demosJSX;
  }

  getRelatedArticlesJSXArray() {
    if (this.props.relatedArticles.length === 0) {
      return null;
    }

    const relatedArticlesJSX = this.props.relatedArticles.map((article) => {
      const articleProps = {
        _id: article._id,
        title: article.title,
        link: `/articles/${article.linkId}`,
        imgSrc: `/images/articles/${article._id}/summary.png`,
        writer: 'Dor Moshe',
        tags: articleTagsService.getRelevantMyArticleTags(article.tags),
        // readMinutes: PropTypes.string,
        buffText: 'Related Article'
      }
      
      return (
        <div 
          key={`project-${this.props._id}-article-${article._id}`}
          className='project-reference-box-container little-grow-animation'>
            <ReferenceBox {...articleProps} />
        </div>
      ); 
    }); 

    return relatedArticlesJSX;
  }
  
        /*<InteractiveContainer 
          className='project-related-article'
          
          link={}
          title={article.title}
          buffText='Related Article'>
              <img 
                height
                src={} 
                title={article.title} 
                alt={article.title} />

              <h3>{article.title}</h3>
        </InteractiveContainer>*/

  render() {
    const descriptionJSX = this.props.description.map((paragraph, i) =>
      <p key={`project-${this.props._id}-description-${i}`}>{paragraph}</p>
    );    

    return (
      <article className='open-source-project'>
        <div className='project-details'>
          <a href={this.props.repoLink} title={this.props.title} target='_blank'>
            <h4>{this.props.title}</h4>
            <h5>{this.props.repoName}, GitHub</h5>            
          </a>  

          <div className='project-section description'>
            {descriptionJSX}
          </div>

          <div className='button-container little-grow-animation'>
            <a href={this.props.repoLink} title={this.props.title} target='_blank'>    
              <Button label="Review in GitHub" isDark={ true } />
            </a>
          </div>

          <div className='project-section related-references-container'>
            {this.getRelatedArticlesJSXArray()}
            {this.getDemosJSXArray()}
          </div>
        </div>
      </article>
    );
  }
}

OpenSourceProject.propTypes = {
  _id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  repoName: PropTypes.string.isRequired,
  repoLink: PropTypes.string.isRequired,
  description: PropTypes.arrayOf(PropTypes.string).isRequired,
  relatedArticles: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired
  })),
  demos: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    repoLink: PropTypes.string.isRequired
  })),
  buffText: PropTypes.string
};

OpenSourceProject.defaultProps = {
  relatedArticles: [],
  demos: []
}

export default OpenSourceProject;